import React from 'react'
import Dashboard from 'containers/Dashboard/Dashboard'

export default function DashboardPage() {
  return <Dashboard />
}
